import { useOnboardingAnalytics } from "analytics/onboarding";
import { OnboardingDetailedStep } from "@shared/features/onboarding/types";
import React, { useContext } from "react";
import Link from "common/Typography/Link";
import MyGroupsMessage from "features/onboarding/methodSettings/signalsGroup/myGroupsMessages/MyGroupsMessage";
import useMedia from "utils/hooks/useMedia";
import { MOBILE_SEARCH } from "common/constants";
import { OnboardingContext } from "@shared/features/onboarding/Onboarding.context";
import { useIsOnboarding } from "utils/hooks/misc";
import { useEmptyState } from "common/Icons/useEmptyState.tsx";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface NoExternalAccountProps {
  showButton?: boolean;
  showLink?: boolean;
}

const NoExternalAccount = ({
  showButton = true,
  showLink = true,
}: NoExternalAccountProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.GROUPS);
  const isMobile = useMedia([`(max-width: ${MOBILE_SEARCH})`], [true], false);
  const { changeStep } = useContext(OnboardingContext) || {};
  const isOnboarding = useIsOnboarding();
  const { Connect } = useEmptyState();
  const track = useOnboardingAnalytics();
  const onClickConnect = () => {
    if (!isOnboarding) return;
    track("Connect Channel Clicked", { placement: "empty_state" });
    changeStep?.(OnboardingDetailedStep.CONNECT_EXTERNAL_ACCOUNT);
  };

  const description =
    isMobile && showLink ? (
      <>
        <Link onClick={onClickConnect}>{t("no_external.connect_link")}</Link>{" "}
        {t("no_external.see_groups_suffix")}
      </>
    ) : (
      <>{t("no_external.description")}</>
    );

  return (
    <MyGroupsMessage
      title={t("no_external.title")}
      icon={
        <Connect
          style={{ width: isMobile ? 100 : 150, height: isMobile ? 70 : 100 }}
        />
      }
      description={description}
      linkText={showButton ? t("buttons.connect_account") : undefined}
      onLinkClick={showButton ? onClickConnect : undefined}
      // Phones: a native empty state, stacked and centred.
      isHorizontal={!isMobile}
    />
  );
};

export default NoExternalAccount;
